import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useState } from "react";

export function CalendarForm({
  setDueDate,
  prevDueDate,
  size = "small",
  placeholder,
}: {
  setDueDate: (date: string) => void;
  prevDueDate: string;
  size?: "small" | "big";
  placeholder?: string;
}) {
  const [date, setDate] = useState<Date | undefined>(undefined);
  const [openPopover, setOpenPopover] = useState(false);

  return (
    <Popover open={openPopover} onOpenChange={setOpenPopover}>
      <PopoverTrigger asChild>
        <div
          className={`w-full font-medium flex flex-row items-center justify-between h-[36px] px-3 rounded-[10px] border-[2px] cursor-pointer ${
            openPopover ? "border-[#0027CB]" : "border-[#D1D5DA]"
          } ${size === "big" && "h-[56px] text-[20px]"}`}
        >
          {date ? (
            format(date, "PPP")
          ) : prevDueDate ? (
            format(prevDueDate, "PPP")
          ) : (
            <span className="text-[#00000080]">{placeholder}</span>
          )}
          <CalendarIcon
            className={`h-4 w-4 opacity-50 bg-[white] ${
              size === "big" && "h-6 w-6"
            }`}
          />
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={(value) => {
            setDate(value);
            if (value) {
              const formattedDate = format(value, "yyyy-MM-dd");
              setDueDate(formattedDate);
              setOpenPopover(false);
            }
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
